import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { EmployeePositionId } from '../../../classes/models/employee/Employee';
import { Capability } from '../../../classes/models/employee/Capability';
import {
  AddEmployeeCapabilityRequest,
  EditEmployeeCapabilityRequest
} from '../../../interfaces/request/EmployeeRequests';

/**
 * This service communicates with backend to handle employee capabilities data management.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeCapabilityService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/employees';

  /**
   * Adds a new capability to the employee.
   * @param id identifiers of employee and position.
   * @param capability a capability to be added.
   */
  addCapability(id: EmployeePositionId, capability: Capability) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/capabilities`;
    const requestBody: AddEmployeeCapabilityRequest = {
      date: capability.startDate,
      capabilities: capability.types
    };
    return this.http.post(url, requestBody);
  }

  /**
   * Edits a capability for the employee.
   * @param id identifiers of employee and position.
   * @param capability a capability to be edited.
   */
  editCapability(id: EmployeePositionId, capability: Capability) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/capabilities/${capability.startDate}`;
    const requestBody: EditEmployeeCapabilityRequest = {
      capabilities: capability.types
    };
    return this.http.put(url, requestBody);
  }

  /**
   * Deletes a capability of the given employee.
   * @param id identifiers of employee and position.
   * @param date start date of capabilities.
   */
  deleteCapability(id: EmployeePositionId, date: string) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/capabilities/${date}`;
    return this.http.delete(url);
  }
}
